import {
    GET_FEE_MARKUP_LIST_SUCCESS,
    GET_FEE_MARKUP_LIST_FAILED,
    RESET_GET_FEE_MARKUP_LIST,
    LOADING_GET_FEE_MARKUP_LIST,
    NETWORK_ERROR_GET_FEE_MARKUP_LIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetFeeMarkupList = () => {
    return { type: RESET_GET_FEE_MARKUP_LIST };
};

const getFeeMarkupList =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_GET_FEE_MARKUP_LIST });
        await partnerServices
            .post("getMarkupList", userData, {
                headers: { AuthToken: authTokenIs },
            })
            .then((res) => {
                switch (res.status) {
                    case 200:
                        dispatch(getFeeMarkupListSuccess(res.data));
                        break;
                    default:
                        dispatch(getFeeMarkupListFailed(res.data));
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_ERROR_GET_FEE_MARKUP_LIST,
                    payload: err,
                });
            });
    };

function getFeeMarkupListSuccess(data) {
    return {
        type: GET_FEE_MARKUP_LIST_SUCCESS,
        payload: data,
    };
}

function getFeeMarkupListFailed(data) {
    return {
        type: GET_FEE_MARKUP_LIST_FAILED,
        payload: data,
    };
}

export {
    resetGetFeeMarkupList,
    getFeeMarkupList,
};